export default "<span>\n\t{{ element | date : 'dd.MM.yyyy' }}\n\t@if (element.includes(':')) {\n\t\t{{ element | date : ' HH:mm' }}\n\t}\n</span>";